import axios from '../../../../../../../../utils/request';

function GET_LIST(params) {
    return axios.get("/ai/AssistantFun/list",{
        params: {
          ...params
        }
    } )
}

function SUBMIT_ADD(params) {
    return  axios.post("/ai/AssistantFun/created",{...params} )
}
function EDIT_DATA(params) {
    return  axios.post("/ai/AssistantFun/info",{ id:params } )
}
function SUBMIT_EDIT(params) {
    return  axios.post("/ai/AssistantFun/updated",{...params} )
}

function DELE(params) {
    return  axios.get("/ai/AssistantFun/deleted",{
        params: {
            ids:params
        }
    } )
}
export default {
    GET_LIST,
    SUBMIT_ADD,
    EDIT_DATA,
    SUBMIT_EDIT,
    DELE
};